<template>
  <div
    class="sub-data"
    v-loading="loading"
    v-show="!onlyRequired || control.required"
    :class="{ 'full-screen': fullScreen }"
  >
    <div class="title-container">
      <div class="name">{{ control.name }} ({{ tableData.length }})</div>
      <div class="operation">
        <span class="btn" :class="{ 'is-disabled': control.disabled }" @click="addRow()">
          <i class="el-icon-plus"></i>
          添加一行
        </span>
        <span class="btn" @click="handleFullScreen" style="margin-left: 10px">
          {{ fullScreen ? "退出全屏" : "全屏" }}
        </span>
      </div>
    </div>
    <base-table
      :height="null"
      ref="baseTable"
      :data="tableData"
      :show-pagination="false"
      v-click-outside="onFormItemBlur"
    >
      <el-table-column width="50" :resizable="false">
        <template #default="scope">
          <div style="text-align:center">{{ scope.$index + 1 }}</div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="control in fillFields"
        :key="control._cid"
        :label="control.name"
        :min-width="220"
        :column-key="control._cid"
      >
        <template #header="scope">
          <span style="display: flex">
            <span style="flex: 1" v-tip>{{ scope.column.label }}</span>
            <dropdown-menu
              v-if="batchAddVisible(control)"
              :menu-list="[{ title: '批量添加', command: 'batchAdd' }]"
              @click="handleCommand($event, control)"
              placement="bottom-end"
              width="120"
              style="flex: 0"
            >
              <span class="pointer">
                <svg-icon icon-class="svgo_arrow-down"></svg-icon>
              </span>
            </dropdown-menu>
          </span>
        </template>
        <template #default="scope">
          <div
            :class="[
              'sub-table-item',
              scope.row.err[control._cid] ? 'is-error' : '',
              getDataControl(scope.row, control._cid).display ? '' : 'is-hidden',
              getDataControl(scope.row, control._cid).disabled ? 'is-disabled' : ''
            ]"
          >
            <span class="required-flag" v-if="getDataControl(scope.row, control._cid).required">
              *
            </span>
            <custom-form-item
              ref="formItem"
              key="formItem"
              v-if="
                curSheetData == scope.row &&
                  curCid == control._cid &&
                  isEditable(scope.row, control._cid)
              "
              v-loading="!curSheetData.formUtil"
              :sheet-data-server="getSheetDataServer(curSheetData)"
              :editable="true"
              :control="getDataControl(scope.row, control._cid)"
              :all-control-map="_.get(curSheetData, 'formUtil.allControlMap')"
              :form="curSheetData.data"
              @change="dataChange(scope.row, control._cid, $event)"
            ></custom-form-item>
            <sub-table-item
              v-else
              key="tableItem"
              :control="getDataControl(scope.row, control._cid)"
              :value="scope.row.data[control._cid]"
              :string-value="_.get(scope.row.dataForShow, control._cid)"
              @click.native.stop="toEdit(scope.row, control._cid)"
            ></sub-table-item>
          </div>
          <div class="err-msg" v-if="scope.row.err[control._cid]">
            {{ scope.row.err[control._cid] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" :resizable="false" width="130px">
        <template slot-scope="scope">
          <div @click.stop style="display:flex">
            <el-button v-if="!control.disabled" type="text" @click="deleteRow(scope)">
              删除
            </el-button>
            <el-button type="text" @click="expandRow(scope.row, scope.$index)">
              展开
            </el-button>
            <el-button v-if="!control.disabled" type="text" @click="copyRow(scope.row)">
              复制
            </el-button>
          </div>
        </template>
      </el-table-column>
    </base-table>
    <edit-sub-dialog
      ref="editSubDialog"
      :available-sheets="availableSheets"
      :control="control"
      :fill-control-map="fillControlMap"
      :disabled-all="disabledAll"
      :first="curIdx <= 0"
      :last="curIdx >= tableData.length - 1"
      :cur-idx="curIdx"
      @submit="editSubDialogSubmit"
      @prev="expandRelativeRow('prev')"
      @next="expandRelativeRow('next')"
    ></edit-sub-dialog>
    <ref-data-dialog
      multiple
      :control="batchAddControl"
      :ref-sheet="refSheetDef"
      :ref-condition="batchRefCondition"
      :dialog-visible.sync="refDataDialogVisible"
      @submit="batchAddSubmit"
    ></ref-data-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/UIComponents/BaseTable"
import { getSheet, getSheetDefForEdit } from "@/api/sheet/sheet"
import { beforeSubmit, transFieldControl } from "@/utils/sheet"
import SubTableItem from "@/components/Sheet/SubTable/SubTableItem"
import { deepClone, randomString } from "@/utils/common"
import CustomFormItem from "@/components/Sheet/SheetForm/FormItem/index.vue"
import FormUtil from "@/components/Sheet/EditDialog/FormUtil"
import EditSubDialog from "@/components/Sheet/SubTable/EditSubDialog.vue"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import RefDataDialog from "@/components/Sheet/RefDataDialog"
import { getSheetDataForEdit } from "@/api/sheet/sheetData"
export default {
  name: "sub-table",
  components: {
    DropdownMenu,
    EditSubDialog,
    CustomFormItem,
    SubTableItem,
    BaseTable,
    RefDataDialog
  },
  props: {
    control: Object,
    availableSheets: Array,
    onlyRequired: Boolean,
    parentData: Object,
    fillSetting: Array, // 按钮填写时传入
    from: String
  },
  data() {
    return {
      tableData: [],
      fillFields: [], // 根据[表定义本身]和[填写设置]计算得到的所有要填写的控件.
      allFields: [],
      curIdx: null,
      curSheetData: null,
      curCid: null,
      fullScreen: false,
      loading: false,
      onParentUpdateDebounced: null,
      batchAddControl: {},
      batchRefCondition: {},
      refSheetDef: {},
      refDataDialogVisible: false
    }
  },
  computed: {
    sheetId() {
      return this.control?.refSheetId
    },
    fillControlMap() {
      return this._.keyBy(this.allFields, "_cid")
    },
    disabledAll() {
      // 当前从表如果是不可编辑并且没有设置任何子字段，则所有子字段都为disabled
      return this.control.disabled && this._.isEmpty(this.fillSetting)
    }
  },
  created() {
    this.emitValDebounced = this._.debounce(this.emitVal, 500)
    this.onParentUpdateDebounced = this._.debounce(this.onParentUpdate, 500)
  },
  methods: {
    async init(sheetDataList) {
      await this.initSheet()
      this.tableData = (this._.cloneDeep(sheetDataList) || []).map(
        ({ id, data, sheetId, dataForShow }) => {
          this.fillFields
            .filter(field => field._type === "ref" && field.oneFlag)
            .filter(field => data[field._cid]?.length == 1 && this._.isString(data[field._cid][0]))
            .forEach(
              field =>
                (data[field._cid] = [
                  { id: data[field._cid][0], title: dataForShow[field._cid] || "加载失败" }
                ])
            )
          return {
            id,
            data,
            dataForShow,
            sheetId,
            tempId: randomString(10),
            formUtil: null, // 等编辑的时候再去初始化
            err: {} // 错误提示
          }
        }
      )
    },
    async initSheet() {
      let isCreate = ["create", "reference"].includes(this.from)
      let sheetDef = isCreate
        ? await getSheetDefForEdit(this.sheetId)
        : await getSheet(this.sheetId)
      let fillCids = (this.fillSetting || []).map(t => t.cid)
      let fillCidMap = this._.chain(this.fillSetting || [])
        .keyBy("cid")
        .mapValues("type")
        .value()
      this.allFields = this._.cloneDeep(sheetDef.controls)
        .map(control => transFieldControl(control))
        .map(control => {
          if (fillCidMap[control._cid] === "R") {
            control.disabled = true
          } else if (fillCidMap[control._cid] === "H") {
            control.required = true
          }
          return control
        })
      this.fillFields = this._.cloneDeep(this.allFields)
        .filter(control => {
          if (isCreate && !control.display) return false // 新建时隐藏
          if (control._type == "code") return false
          if (control._type == "remark") return false
          if (control._type == "ref" && control._cid == this.control._ccid) return false
          if (fillCids.length && !fillCids.includes(control._cid)) return false // 过滤不需要填写的字段
          return true
        })
        .sort((a, b) => {
          if (this.fillSetting?.length) {
            // 按照按钮设置的顺序填写
            return (
              fillCids.findIndex(cid => cid === a._cid) - fillCids.findIndex(cid => cid === b._cid)
            )
          }
          // 否则按照此从表的字段顺序
          let ai = this.control.fields.findIndex(c => c === a._cid)
          let bi = this.control.fields.findIndex(c => c === b._cid)
          ai = ai < 0 ? 1000 : ai
          bi = bi < 0 ? 1000 : bi
          return ai - bi
        })
    },
    async onParentUpdate() {
      if (!this.control._ccid) return
      let updateObj = { [this.control._ccid]: [this.parentData] }
      for (const row of this.tableData) {
        await this.initFormUtil(row)
        await row.formUtil.handleFieldUpdate({ form: row.data, updateObj })
      }
    },
    async addRow(initData = {}) {
      if (this.control.disabled) return
      let sheetData = {
        id: null,
        sheetId: this.sheetId,
        tempId: randomString(6),
        data: {},
        err: {}
      }
      this.tableData.push(sheetData)
      await this.initFormUtil(
        sheetData,
        this.tableData.filter(sheetData => !sheetData.id).length + 1
      )
      if (this.control._ccid) {
        initData[this.control._ccid] = [this.parentData]
      }
      await sheetData.formUtil.initForCreate(sheetData.data, initData)
    },
    deleteRow({ $index }) {
      this.tableData.splice($index, 1)
      this.emitValDebounced()
    },
    async copyRow(rawSheetData) {
      let sheetData = {
        id: null,
        sheetId: this.sheetId,
        tempId: randomString(6),
        data: {},
        err: {}
      }
      await this.initFormUtil(
        sheetData,
        this.tableData.filter(sheetData => !sheetData.id).length + 1
      )
      this.tableData.push(sheetData)
      await sheetData.formUtil.initForCopy(sheetData.data, rawSheetData.data)
    },
    async expandRow(sheetData, idx) {
      this.curIdx = idx
      this.curSheetData = sheetData
      await this.initFormUtil(sheetData)
      let data = deepClone(sheetData.data)
      this._.keys(data).forEach(key => {
        let control = this.fillControlMap[key]
        if (control?._type === "ref" && !control.oneFlag) {
          let value = data[key]
          if (this._.isArray(value) && value.length) {
            if (this._.isString(value[0])) {
              data[key] = sheetData.dataForShow[key]
            } else {
              let firstField = control.fields[0]
              data[key] = value.map(item => item.data[firstField]).join(",")
            }
          }
        }
      })
      this.$refs.editSubDialog.open(data, sheetData.formUtil)
    },
    expandRelativeRow(type) {
      let idx = this.curIdx + (type == "next" ? 1 : -1)
      if (0 <= idx && idx < this.tableData.length) {
        this.expandRow(this.tableData[idx])
        this.curIdx = idx
      }
    },
    async editSubDialogSubmit(form) {
      await this.curSheetData.formUtil.handleFieldUpdate({
        form: this.curSheetData.data,
        updateObj: form
      })
      this.validateField(
        this.curSheetData,
        this.fillFields.map(t => t._cid)
      )
      this.emitValDebounced()
    },
    async initFormUtil(sheetData, snStep = 1) {
      if (sheetData.formUtil) return
      sheetData.formUtil = new FormUtil({
        dataId: sheetData.id,
        sheetInfo: await getSheetDefForEdit(this.sheetId, sheetData.id),
        availableSheets: this.availableSheets,
        snStep,
        fillFields: this.fillFields,
        formGetterFunc: () => sheetData.data,
        updateFormFunc: ({ updateObj }) => {
          sheetData.data = Object.assign({}, sheetData.data, updateObj)
          let changeCids = Object.keys(updateObj)
          if (changeCids.length == 1 && changeCids[0] == this.control._ccid) return
          // console.log("subtable updateFormFunc", this._.cloneDeep(updateObj))
          this.validateField(sheetData, Object.keys(updateObj))
          this.emitValDebounced()
        }
      })
    },
    async toEdit(sheetData, cid) {
      if (!this.isEditable(sheetData, cid)) return
      this.curSheetData = sheetData
      this.curCid = cid
      await this.initFormUtil(sheetData)
      await this.$nextTick()
      this.$refs.formItem[0]?.init(this.curSheetData.data[this.curCid])
      this.$refs.formItem[0]?.focus()
    },
    dataChange(sheetData, cid, val) {
      sheetData.formUtil.handleFieldUpdate({
        form: sheetData.data,
        updateObj: { [cid]: val }
      })
      this.validateField(sheetData, [cid])
      this.emitValDebounced()
    },
    onFormItemBlur() {
      if (!this.curCid) return
      setTimeout(() => (this.curCid = null), 350) // 部分form-item需要300ms触发更新
    },
    getDataControl(sheetData, cid) {
      let control = sheetData.formUtil
        ? sheetData.formUtil.controlMap[cid]
        : this.fillControlMap[cid]
      if (this.disabledAll) {
        return Object.assign({}, control, { disabled: true })
      }
      return control
    },
    getSheetDataServer(sheetData) {
      return sheetData.formUtil?.getSheetDataServer(sheetData.data, sheetData.id, false) || {}
    },
    isEditable(sheetData, cid) {
      let control = this.getDataControl(sheetData, cid)
      return control.display && !control.disabled
    },
    validateField(sheetData, cids) {
      let valid = true
      if (sheetData && !this._.isEmpty(cids)) {
        cids.forEach(cid => {
          const val = sheetData.data[cid]
          const rules = sheetData.formUtil?.rules[cid]
          if (!rules) {
            this.$set(sheetData.err, cid, null)
            return
          }
          for (const rule of rules) {
            const { validator } = rule
            validator(rule, val, errMsg => {
              this.$set(sheetData.err, cid, errMsg)
              if (errMsg) valid = false
            })
            if (!valid) break
          }
        })
      }
      return valid
    },
    validate() {
      if (this.control.required && this._.isEmpty(this.tableData)) {
        this.$message.error(`${this.control.name}为必填项！`)
        return false
      }
      let cids = this.fillFields.map(c => c._cid)
      for (const sheetData of this.tableData) {
        if (!this.validateField(sheetData, cids)) return false
      }
      return true
    },
    emitVal() {
      this.$emit(
        "change",
        this.tableData.map(({ id, data }) => ({
          id,
          sheetId: this.sheetId,
          data: beforeSubmit({
            form: this._.omit(data, this.control._ccid),
            fieldsMap: this.fillControlMap,
            skipRelatedControl: false
          })
        }))
      )
    },
    handleFullScreen() {
      this.fullScreen = !this.fullScreen
      this.$emit("full-screen", this.fullScreen)
    },
    async handleCommand(cmd, control) {
      switch (cmd) {
        case "batchAdd": {
          this.batchAddControl = control
          this.refSheetDef = await getSheet(control.refSheetId)
          let sheetDataServer = await this.getDefaultSheetDataServer()
          this.batchRefCondition = {
            refSheetId: sheetDataServer.sheetId,
            refControlId: control?._cid,
            refSheetData: sheetDataServer
          }
          await this.$nextTick()
          this.refDataDialogVisible = true
          break
        }
      }
    },
    async getDefaultSheetDataServer() {
      let sheetData = { id: null, sheetId: this.sheetId, data: {}, err: {} }
      await this.initFormUtil(sheetData)
      let initData = {}
      if (this.control._ccid) {
        initData[this.control._ccid] = [this.parentData]
      }
      await sheetData.formUtil.initForCreate(sheetData.data, initData)
      return sheetData.formUtil.getSheetDataServer(sheetData.data, sheetData.id, false)
    },
    batchAddVisible(c) {
      if (this.control.disabled) return false
      return c._type === "ref" && c.oneFlag && !c.disabled
    },
    async batchAddSubmit(sheetDataList) {
      try {
        this.loading = true
        let sheetId = this.batchAddControl.refSheetId
        // todo 替换成批量获取数据详情接口
        sheetDataList = await Promise.all(
          sheetDataList.map(({ id }) =>
            getSheetDataForEdit({
              dataId: id,
              appId: this.refSheetDef.appId,
              sheetId,
              withDetail: true,
              withString: false
            })
          )
        )
        for (const sheetData of sheetDataList) {
          await this.addRow({ [this.batchAddControl._cid]: [sheetData] })
        }
        this.$message.success("添加成功")
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-data {
  background: white;
  &.full-screen {
    position: fixed !important;
    width: 100vw !important;
    height: 100vh !important;
    padding: 14px 20px 0 40px !important;
    .base-table {
      height: calc(100vh - 48px - 14px);
      width: 100vw;
      max-width: 100vw;
      margin-left: -40px;
      max-height: unset !important;
      ::v-deep .el-table__body-wrapper {
        height: calc(100% - 51px);
        max-height: unset;
      }
      ::v-deep {
        .el-table__fixed-body-wrapper {
          height: calc(100% - 51px);
          max-height: unset;
        }
      }
    }
  }
  .title-container {
    position: relative;
    display: flex;
    margin-bottom: 20px;
    color: $color-font-first;
    font-size: $font-size-title-topic;
    line-height: 28px;
    &::before {
      content: "";
      position: absolute;
      left: -22px;
      width: 6px;
      height: 28px;
      border-radius: 4px;
      background-color: $color-main;
    }
    .name {
      margin-right: auto;
    }
    .operation {
      font-size: $font-size-title-topic;
      .btn {
        font-size: $font-size-main;
        height: 28px;
        line-height: 28px;
        color: $color-main;
        cursor: pointer;
        &:hover {
          color: #66b1ff;
        }
        & + .btn {
          margin-left: 10px;
        }
        &.is-disabled {
          color: $color-font-second;
          cursor: not-allowed;
        }
      }
    }
  }
  .base-table {
    .sub-table-item {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      &.is-error {
        .sub-table-item {
          border-color: #f56c6c !important;
          &:hover {
            box-shadow: 0 0 2px 0 #f56c6c !important;
          }
        }
        ::v-deep {
          .el-input__inner,
          .el-textarea__inner {
            border-color: #f56c6c;
          }
        }
      }
      &.is-disabled,
      &.is-hidden {
        .sub-table-item {
          border-color: transparent !important;
          box-shadow: none !important;
          ::v-deep .empty {
            display: block !important;
          }
        }
      }
      .required-flag {
        color: #f56c6c;
        margin-right: 5px;
      }
      .custom-form-item {
        flex: 1;
        overflow: hidden;
        background: #ffffff;
      }
      .sub-table-item {
        flex: 1;
        margin: 2px 0; // 防止阴影被遮挡
        min-height: 32px;
        border: 1px solid transparent;
        padding: 0 10px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 4px;
      }
    }
    .err-msg {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding: 4px 10px 0;
    }
    ::v-deep {
      .el-table__fixed-body-wrapper,
      .el-table__body-wrapper {
        max-height: 200px;
        tr {
          .cell {
            padding-left: 5px;
            padding-right: 5px;
          }
        }
        tr:hover {
          .sub-table-item {
            &.is-disabled,
            &.is-hidden {
              .sub-table-item {
                background: #e7eaee;
                border-radius: 4px;
              }
            }
            .sub-table-item {
              border-color: #dcdfe6;
              .empty {
                display: none;
              }
              &:hover {
                border-color: #1989fa;
                box-shadow: 0 0 2px 0 #1989fa;
              }
            }
          }
        }
      }
    }
  }
}
</style>
